import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .intersection-observer-wrap:last-child {
    .text-area {
      border-bottom: none;
      padding-bottom: 0;
    }
  
`;